import type { PatientDataInput } from '../graphql/generated/graphql.ts';
import { normalizeImportResult } from './importResult.ts';

/** A preselected parameter; the desktop import (L-Werte) names no lab. */
export interface ImportParameterRef {
  readonly labId: string | null;
  readonly shortName: string;
}

export interface ImportFileParseResult {
  readonly invalidPatientFields: string[];
  readonly invalidAdditionalDataFields: string[];
  readonly diagnose: string;
  readonly additionalData: Record<string, string>;
  readonly patientData: PatientDataInput;
  readonly switchToDoctorId: string | null;
  readonly profiles: string[];
  readonly parameters: ImportParameterRef[];
}

export const aisImport = (jwtToken: string, currentDoctorId: string): Promise<ImportFileParseResult> =>
  // biome-ignore lint/suspicious/noAsyncPromiseExecutor: requires sequential native API calls
  new Promise(async (resolve, reject) => {
    if (!window.nativeApi) {
      return reject('Native API not available');
    }

    try {
      const uint8Array = await window.nativeApi.readImportFile();
      const data = new FormData();
      data.append('file', new Blob([uint8Array], { type: 'text/plain' }));
      data.append('doctorId', currentDoctorId);

      const endpoint = `${window._env_.API_URL}/rest/import-file`;
      const response = await fetch(endpoint, {
        method: 'POST',
        body: data,
        headers: { authorization: `Bearer ${jwtToken}` },
      });
      if (!response.ok) {
        return reject('Unable to read import file');
      }
      const result = (await response.json()) as ImportFileParseResult;

      resolve(normalizeImportResult(result));
    } catch (e) {
      return reject(e);
    }
  });
